module.exports = __webpack_public_path__ + "static/media/logo-reversed.f69d0b8f.svg";